import { useTranslation } from 'react-i18next';
import Card, { StatCard } from '../ui/Card';

// Cardurile de sinteză pentru raportul ITM: total angajați, procent conformitate,
// neconformi, EIP. Primesc obiectul `summary` returnat de backend.
const PeopleIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);
const CheckIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);
const WarnIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    />
  </svg>
);
const ShieldIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
    />
  </svg>
);

const ComplianceSummary = ({ summary }) => {
  const { t } = useTranslation();
  if (!summary) return null;
  const comp = summary.compliance || {};

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard
        label={t('globalReports.totalEmployees')}
        value={summary.total}
        icon={<PeopleIcon />}
      />
      <Card>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
              {t('globalReports.compliantPercent')}
            </p>
            <p className="mt-1 text-2xl font-semibold text-slate-900 dark:text-slate-100 tabular-nums">
              {comp.compliantPercent ?? 0}%
            </p>
            <p className="mt-1 text-xs text-slate-400 dark:text-slate-400">
              {t('globalReports.compliantOf', {
                ok: comp.compliant ?? 0,
                total: comp.evaluated ?? 0,
              })}
            </p>
          </div>
          <div className="w-10 h-10 rounded-lg bg-accent-50 dark:bg-accent-950/50 flex items-center justify-center text-accent-600 dark:text-accent-300 flex-shrink-0">
            <CheckIcon />
          </div>
        </div>
      </Card>
      <StatCard
        label={t('globalReports.nonCompliant')}
        value={comp.nonCompliant ?? 0}
        icon={<WarnIcon />}
      />
      <StatCard
        label={t('globalReports.epiDistributed')}
        value={`${summary.epi} / ${summary.total}`}
        icon={<ShieldIcon />}
      />
    </div>
  );
};

export default ComplianceSummary;
